module.exports = __webpack_public_path__ + "static/media/SF2011_04.8a6771ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/SF2011_04.jpg
// module id = 383
// module chunks = 0